import { atom } from 'jotai';

export const isMobileSearchVisibleAtom = atom(false);
